import { useTranslation } from 'react-i18next';
import { Nav, Navbar, NavItem } from 'reactstrap';
import { useProfileState } from 'context/profile';



export function MainHeader({ children, title, showLogo = true }) {
    const { t } = useTranslation();
    const { profile } = useProfileState();

    return (
        <Navbar>
            {showLogo ?
                <img
                    className="company-img-size mr-auto"
                    src={profile.tenant?.branding?.logo || '/images/logo-01.svg'}
                    alt="brand-logo" /> :
                <h2>{t(title)}</h2>
            }
            <Nav className="mr-right" navbar>
                <NavItem>
                    {children}
                </NavItem>
            </Nav>
        </Navbar>
    )
}